import { Link } from "react-router-dom";
import { ArrowRight, Truck, Briefcase, TrendingUp, MapPinned, Cpu } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useSite } from "@/lib/content";

const ICONS = { Truck, Briefcase, TrendingUp, MapPinned, Cpu };

export default function IndustriesSection() {
  const { data } = useSite();
  const industries = data?.industries || [];

  return (
    <section className="bg-void py-28 sm:py-36" data-testid="industries-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Industries</Eyebrow>
          <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Software capabilities that adapt to your industry.
            </h2>
            <Link
              to="/industries"
              data-testid="industries-explore-link"
              className="group inline-flex items-center gap-2 text-sm font-semibold text-blue-400 transition-colors hover:text-blue-300"
            >
              Explore industries
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {industries.map((ind, i) => {
            const Icon = ICONS[ind.icon] || Briefcase;
            return (
              <Reveal key={ind.id || ind.slug} delay={i * 0.06} y={20}>
                <div
                  className="group h-full rounded-2xl border border-slate-800/80 bg-navy/60 p-6 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-blue-500/40"
                  data-testid={`industry-card-${ind.slug}`}
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-blue-500/25 bg-blue-500/10 text-blue-400">
                    <Icon size={18} />
                  </span>
                  <h3 className="mt-5 font-display text-base font-semibold leading-snug text-white">{ind.name}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-slate-400">{ind.summary}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
